var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"invoice_list"}},[_c('tab',{attrs:{"id":"list","name":_vm.translate('invoice.many'),"href":_vm.url+'list'}},[_c('List')],1),_c('tab',{attrs:{"id":"currency_rate","name":_vm.translate('invoice.currency_rate'),"href":_vm.url+'currency_rate'}},[_c('CurrencyRate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }